import store from "../../store/store"

export default (to, from, next) => {
  const isProtectedRoute = to.matched.some((record) => record.meta.authenticate)
  if (isProtectedRoute && !store.getters.isAuthenticated) {
    store.commit("SET_AUTHENTICATED", false)
    store.commit("SET_AUTH_ERROR", true)
    return
  } else if (!isProtectedRoute) {
    store.commit("SET_AUTH_ERROR", false)
  }

  next()
}
